"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var GridListCell =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridListCell, _React$Component);

  function GridListCell() {
    _classCallCheck(this, GridListCell);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridListCell).apply(this, arguments));
  }

  _createClass(GridListCell, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.classes()
      }, this.props.display(this.props.item));
    }
  }, {
    key: "classes",
    value: function classes() {
      var _this = this;

      var str = 'list-cell';
      var sizes = ['xs', 'sm', 'md', 'lg'];
      sizes.forEach(function (s) {
        if (_this.props[s]) {
          str += " col-".concat(s, "-").concat(_this.props[s]);
        }
      });
      return str;
    }
  }]);

  return GridListCell;
}(_react.default.Component);

GridListCell.defaultProps = {
  display: function display() {}
};
GridListCell.propTypes = {
  xs: bootstrapCellSizePropType,
  sm: bootstrapCellSizePropType,
  md: bootstrapCellSizePropType,
  lg: bootstrapCellSizePropType,
  display: _propTypes.default.func
};

function bootstrapCellSizePropType(props, propName, componentName) {
  if (!props[propName]) {
    return null;
  }

  var sizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  var passedSize = parseInt(props[propName]);

  if (sizes.indexOf(passedSize) === -1) {
    return new Error("".concat(propName, " of ").concat(componentName, " not a valid bootstrap column size"));
  }

  return null;
}

var _default = GridListCell;
exports.default = _default;